import { Box, styled } from '@mui/material';

import FormatNumberInput from '@Components/FormattedNumberInput';
import { FormInput } from '@Components/Form';
import { disabledFormInputStyles } from '@Components/Form/styles';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import {
  IIncomeItemFormValues,
  IIncomeStructureFormValues,
} from '../../NatureOfBusinessFormProvider/types';
import { calcNetIncomeItem, yearFields } from '../utils';
import {
  OTHER_INCOME_TYPE_ID,
  TOTAL_INCOME_STRUCTURE_ID,
} from 'src/Enum/IncomeStructure';

const FormNumberInput = styled(FormInput)({
  '& input': {
    textAlign: 'right',
  },
});

type OtherIncomeYearFieldsFormProps = {
  keyItem: string;
};

const OtherIncomeYearFieldsForm = ({
  keyItem,
}: OtherIncomeYearFieldsFormProps) => {
  const { watch, getValues, setValue } = useNatureOfBusinessForm();
  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const { isCompletedTh = false, isCompletedEn = false } =
    incomeStructure?.completedSection ?? {};

  const calcNonOperationIncome = (yearField: keyof IIncomeItemFormValues) => {
    const otherIncomeItems = getValues(`incomeStructure.otherIncomeItems`);
    const totalValue = otherIncomeItems[
      TOTAL_INCOME_STRUCTURE_ID.TOTAL_OTHER_INCOME
    ][yearField] as string;
    const operationValue = otherIncomeItems[OTHER_INCOME_TYPE_ID.OPERATIONS][
      yearField
    ] as string;

    if (totalValue !== '' && operationValue !== '') {
      setValue(
        `incomeStructure.otherIncomeItems.${OTHER_INCOME_TYPE_ID.NON_OPERATIONS}.${yearField}`,
        calcNetIncomeItem(totalValue, operationValue)
      );
    } else {
      setValue(
        `incomeStructure.otherIncomeItems.${OTHER_INCOME_TYPE_ID.NON_OPERATIONS}.${yearField}`,
        ''
      );
    }
  };

  const handleChange = (yearField: keyof IIncomeItemFormValues) => {
    if (
      keyItem === TOTAL_INCOME_STRUCTURE_ID.TOTAL_OTHER_INCOME.toString() ||
      keyItem === OTHER_INCOME_TYPE_ID.OPERATIONS.toString()
    ) {
      calcNonOperationIncome(yearField);
    }
  };

  return (
    <Box
      width={1}
      display={'grid'}
      gridTemplateColumns={'repeat(3, 1fr)'}
      gap={3}
      ml={1}
    >
      {yearFields.map((yearField) => (
        <FormNumberInput
          key={`${keyItem}-${yearField}`}
          name={`incomeStructure.otherIncomeItems.${keyItem}.${yearField}`}
          placeholder={'กรุณาระบุจำนวน'}
          slotProps={{
            input: {
              inputComponent: FormatNumberInput as React.ComponentType,
            },
          }}
          fullWidth
          sx={
            isCompletedTh || isCompletedEn ? disabledFormInputStyles : undefined
          }
          onChange={() => handleChange(yearField)}
        />
      ))}
    </Box>
  );
};

export default OtherIncomeYearFieldsForm;
